module.exports = __webpack_public_path__ + "static/CardOfDarkness6-f3f9f0ccefb79cb2b61f2b4f7092a89b.png";